import React, { Component } from 'react';
import './App.css';


class Releases extends Component {

  scrollToTop(){   
    const element = document.querySelector('.youtube');
    element.scrollIntoView({behavior: "smooth"});    
  }

  render() {
	const releases =  this.props.releases.map(release => {		
		return (
			<div style={{zIndex:"99", position:"relative"}} onClick={() => {this.props.onReleaseSelect(release); this.scrollToTop()}}  key={release.name}>
				<img className="thumb" alt={release.name} src={"../img/"+release.imageName}/>
				<h2 className="thumbTitle">{release.name}</h2>
				<p className="thumbText">Ranked {release.rank} place in the {release.compo} compo @ {release.party}</p>
			</div>)
	});

	return (

			<div className="grid">			
				{releases}
				{
					//<OneLiner chatPosts={this.props.chatPosts} addChat={this.props.addChat}/>
				}
		<iframe width="369" height="450" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/589027920%3Fsecret_token%3Ds-1Smf1&color=%233c4c3c&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true" id="soundcloud"></iframe>
			</div>
		
	);
  }
}

export default Releases;


// WEBPACK FOOTER //
// ./src/release-list.js